import FormStep from "~/components/BusinessSchedulingPage/FormStep";
import SchedulingSection from "~/components/BusinessSchedulingPage/SchedulingSection";
import ObservationSection from "~/components/BusinessSchedulingPage/ObservationSection";
import ScheduleButton from "~/components/BusinessSchedulingPage/ScheduleButton";
import Spinner from "~/shared/Spinner";
import React, { Dispatch, SetStateAction } from "react";
import { ScheduleJob } from "~/types/jobs";
import { StringRecord } from "~/types/record";
import JobKeyAddressSection from "~/components/BusinessSchedulingPage/JobKeyAddressSection";

type UpdateFieldsFn = (state: Partial<ScheduleJob>, value: any) => Partial<ScheduleJob>;

type SchedulingProps = {
    onSubmit: (event: React.FormEvent<HTMLFormElement>) => Promise<void>;
    handleBlur: (name: string, value: any) => void;
    handleChange: (name: string, value: any, options?: { extra?: boolean, updateFn?: UpdateFieldsFn }) => void;
    token: string;
    errors: StringRecord;
    schedulingConfig: any;
    fields: any;
    submitting: boolean;
    setJobKeyInOtherPlace: Dispatch<SetStateAction<"sim" |"nao">>;
    jobKeyInOtherPlace: "sim" |"nao";
};

export const Scheduling = ({ schedulingConfig, fields, errors, token, submitting, onSubmit, handleChange, handleBlur, setJobKeyInOtherPlace, jobKeyInOtherPlace }: SchedulingProps) => {

    return (
        <form onSubmit={onSubmit}>
            <FormStep noWrap style={{ background: "transparent" }}>
                <div className="mb-4 pt-4">
                    <SchedulingSection
                        fields={fields}
                        errors={errors}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        schedulingTimeCalculation={schedulingConfig.schedulingTimeCalculation}
                        token={token}
                    />
                </div>

                <div className="mb-4">
                    <ObservationSection
                        fields={fields}
                        errors={errors}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                    />
                </div>

                {
                    fields.organizationId === 80 && (
                        <JobKeyAddressSection
                            fields={fields}
                            errors={errors}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            setJobKeyInOtherPlace={setJobKeyInOtherPlace}
                            jobKeyInOtherPlace={jobKeyInOtherPlace}
                        />
                    )
                }

                <ScheduleButton disabled={submitting}>
                    {submitting ? <Spinner /> : "Agendar"}
                </ScheduleButton>
            </FormStep>
        </form>
    );
}
